module.exports = __webpack_public_path__ + "static/media/38.ab131b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/38.jpg
// module id = 407
// module chunks = 0